export default "__VITE_ASSET__$$wcYYY9__"